import { jsx } from "react/jsx-runtime";
import { getDataTestId } from "../../../Util/index.js";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./constants.js";
import { StyledListItem } from "./styles.js";
const ListItem = (props) => {
  const { children, uniqueId } = props;
  if (!children) {
    console.error(`${INVALID_PROPS_ERROR} Missing required children prop.`);
    return null;
  }
  return /* @__PURE__ */ jsx(
    StyledListItem,
    {
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      ...props,
      children
    }
  );
};
ListItem.displayName = COMPONENT_NAME;
export {
  ListItem
};
